import SettingsMetaData from "../../../../../Components/Hooks/useSettingsMetaData";

const Status = () => {
  return(
    <SettingsMetaData propertyName={"AgentStatus"} viewPropertyName={"Agent Status"} />
  )
};

export default Status;
